/**
 * A chave da mensagem quando a resposta de erro não traz JSON nosso (techspec-cloudflare-borda §05.3).
 *
 * Atrás da Cloudflare, o bloqueio da borda (limite de pedidos, WAF) e a origem fora do ar (52x) chegam como página
 * HTML dela. O JSON da API, quando existe, continua mandando: esta é só a reserva.
 */
export function chaveDoErroSemJson(status: number): string {
  if (status === 401) return 'auth.badCredentials';
  if (status === 404) return 'comum.rotaSumida';
  if (status === 429) return 'auth.rateLimited';
  if (status === 502 || status === 503 || status === 504 || (status >= 520 && status <= 527)) return 'auth.unavailable';
  return 'comum.recusouPedido';
}
